<template>
	<vx-card :title='$t("Tags")'>
		<vs-table ref="table" v-model="selected" @selected="handleSelected" pagination :max-items="50" search :data="tags">

			<div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

				<div class="flex flex-wrap-reverse items-center">
					<vs-button type="border" color="success" icon-pack="feather" icon="icon-plus-circle" @click="addTagPrompt = true">{{$t("Add")}}</vs-button>
				</div>

				<vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
					<div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
						<span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ tags.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : tags.length }} of {{ tags.length }}</span>
						<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
					</div>

					<vs-dropdown-menu>

						<vs-dropdown-item @click="itemsPerPage=10">
							<span>10</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="itemsPerPage=20">
							<span>20</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="itemsPerPage=50">
							<span>50</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="itemsPerPage=100">
							<span>100</span>
						</vs-dropdown-item>
					</vs-dropdown-menu>
				</vs-dropdown>
			</div>

			<template slot="thead">
				<vs-th sort-key="name">{{$t("Name")}}</vs-th>
				<vs-th sort-key="global">{{$t("GlobalTag")}}</vs-th>
			</template>

			<template slot-scope="{data}">
				<tbody>
				<vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

					<vs-td :data="data[index].name">
						<vs-chip class="mr-3" :color="data[index].color">
							<p v-bind:style="{color: data[index].text_color}"><b>{{ data[index].name}}</b></p>
						</vs-chip>
					</vs-td>

					<vs-td :data="data[index].global">
						{{ ((data[index].global) ? $t("Yes") : $t("No")) }}
					</vs-td>

				</vs-tr>
				</tbody>
			</template>

		</vs-table>

		<vs-popup :title="$t('Add')" :active.sync="addTagPrompt">
			<div>
				<vs-checkbox class="mb-6" v-model="addTagObject['global']">{{$t("GlobalTag")}}</vs-checkbox>

				<p class="mt-6">{{$t("Name")}}</p>
				<vs-input v-model="addTagObject['name']" style="width: 100%"/>

				<p class="mt-6">{{$t("Color")}}</p>
				<vs-input v-model="addTagObject['color']" style="width: 100%"/>
				<div class="colorPicker" v-bind:style="{backgroundColor: addTagObject['color']}">
					<input type="color" v-model="addTagObject['color']" />
					<p v-bind:style="{color: addTagTextColor}"><b>{{addTagObject['name']}}</b></p>
				</div>
				<vs-divider/>
				<vs-button color="success" type="border" class="mt-6; mr-1" @click="addTag">{{$t("Add")}}</vs-button>
			</div>
		</vs-popup>

		<vs-popup :title="$t('Edit')" :active.sync="editTagPrompt">
			<div>
				<vs-checkbox class="mb-6" v-model="editTagObject['global']">{{$t("GlobalTag")}}</vs-checkbox>

				<p class="mt-6">{{$t("Name")}}</p>
				<vs-input v-model="editTagObject['name']" style="width: 100%"/>

				<p class="mt-6">{{$t("Color")}}</p>
				<vs-input v-model="editTagObject['color']" style="width: 100%"/>
				<div class="colorPicker" v-bind:style="{backgroundColor: editTagObject['color']}">
					<input type="color" v-model="editTagObject['color']" />
					<p v-bind:style="{color: editTagTextColor}"><b>{{editTagObject['name']}}</b></p>
				</div>
				<vs-divider/>
				<vs-button style="float: left" color="success" icon-pack="feather" icon="icon-edit" type="border" class="mt-6; mr-1" @click="editTag">{{$t("Change")}}</vs-button>
				<vs-button style="float: right" type="border" color="danger" icon-pack="feather" icon="icon-trash-2" @click="removeTag">{{$t("Delete")}}</vs-button>
			</div>
		</vs-popup>
	</vx-card>
</template>
<script>

	import vSelect from 'vue-select'

	export default {
		components: {
			'v-select': vSelect,
		},
		data() {
			return {
				selected: {},
				tags: [],

				selectedTags: [],

				itemsPerPage: 20,
				isMounted: false,

				addTagPrompt: false,
				editTagPrompt: false,

				addTagObject: {color: '#FFFFFF'},

				editTagObject: {},
			}
		},
		computed: {
			currentPage() {
				if(this.isMounted) {
					return this.$refs.table.currentx
				}
				return 0
			},
			addTagTextColor(){
				if(!this.addTagObject.color) return "#222222";
				let rgbColor = this.hexToRgb(this.addTagObject.color);
				let lightness = rgbColor.r*0.299 + rgbColor.b*0.114 + rgbColor.g*0.587;
				if(lightness > 170) return "#222222";
				return "#ffffff"
			},
			editTagTextColor(){
				if(!this.editTagObject.color) return "#222222";
				let rgbColor = this.hexToRgb(this.editTagObject.color);
				let lightness = rgbColor.r*0.299 + rgbColor.b*0.114 + rgbColor.g*0.587;
				if(lightness > 170) return "#222222";
				return "#ffffff"
			}
		},
		methods: {
			handleSelected(tr) {
				this.editTagObject = JSON.parse(JSON.stringify(tr));
				this.editTagPrompt = true;
			},
			hexToRgb(hex) {
				var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
				hex = hex.replace(shorthandRegex, function(m, r, g, b) {
					return r + r + g + g + b + b;
				});

				var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
				return result ? {
					r: parseInt(result[1], 16),
					g: parseInt(result[2], 16),
					b: parseInt(result[3], 16)
				} : null;
			},
			updateTags() {
				const thisIns = this;
				this.$http.get('/api/v1/tags/')
						.then(function (response) {
							thisIns.tags = response.data;
						})
						.catch(function (error) {
							thisIns.$vs.notify({
								title:'Error',
								text: error,
								color:'danger',
								iconPack: 'feather',
								icon:'icon-alert-circle'})
						});
			},
			addTag() {
				const thisIns = this;

				this.addTagObject['text_color'] = this.addTagTextColor;

				this.$http.post('/api/v1/tags/', this.addTagObject
				).then(function () {
					thisIns.updateTags();
					thisIns.addTagPrompt = false;
					thisIns.addTagObject = {};
				}).catch(function (error) {
					thisIns.addTagPrompt = false;
					thisIns.$vs.notify({
						title:'Error',
						text: error.response.data,
						color:'danger',
						iconPack: 'feather',
						icon:'icon-alert-circle'})
				});
			},
			editTag() {
				const thisIns = this;

				this.editTagObject['text_color'] = this.editTagTextColor;

				this.$http.put('/api/v1/tags/' + this.selected.id, this.editTagObject
				).then(function () {
					thisIns.updateTags();
					thisIns.editTagPrompt = false;
				}).catch(function (error) {
					thisIns.editTagPrompt = false;
					thisIns.$vs.notify({
						title:'Error',
						text: error.response.data,
						color:'danger',
						iconPack: 'feather',
						icon:'icon-alert-circle'})
				});
			},
			removeTag() {
				const thisIns = this;
				this.$http.delete('/api/v1/tags/' + this.selected.id)
						.then(function () {
							thisIns.updateTags();
							thisIns.editTagPrompt = false;
						}).catch(function (error) {
							thisIns.editTagPrompt = false;
							thisIns.$vs.notify({
								title:'Error',
								text: error.response.data,
								color:'danger',
								iconPack: 'feather',
								icon:'icon-alert-circle'})
						});
			}
		},
		watch: {
			editTagPrompt: function () {
				if(!this.editTagPrompt){
					this.selected = {}
				}
			}
		},
		created() {
			this.updateTags()
		},
		mounted() {
			this.isMounted = true;
		},
		beforeRouteLeave (to, from, next) {
			if(this.addTagPrompt){
				this.addTagPrompt = false;
				next(false)
			}else if(this.editTagPrompt){
				this.editTagPrompt = false;
				next(false)
			}else{
				next()
			}
		}
	}
</script>
<style lang="scss">

	.colorPicker{
		display: block;
		position: relative;
		width: 100px;
		height: 100px;
		margin: 10px;
		display: flex;
		align-items: center;
		justify-content: center;
		color: rgb(255, 255, 255);
		border-radius: 10px;
		cursor: default;
		flex-direction: column;
		text-align: center;
		padding: 10px;
		transition: all .2s ease;
		cursor: pointer;
	}
	.colorPicker {
		transform: translate(0,8px);
		box-shadow: 0px 0px 40px -10px rgba(255, 255, 255,0) !important;
	}
	.colorPicker input{
		position: absolute;
		width: 100%;
		height: 100%;
		opacity: 0;
		cursor: pointer;
	}

</style>
